import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface IFormAction {
  id: string
  [key: string]: any
}
interface IInitialState {
  [key: string]: { [key: string]: any }
}

const initialState: IInitialState = {


}
const FormsSlice = createSlice({
  name: 'forms',
  initialState,
  reducers: {
    addImage: (state, action: PayloadAction<{id:string,localUrl:string, name: string}>) => {
      const {id,...rest} = action.payload
      state[id] = {...rest}
    },
    addValueToList: (state, action) => {},
    setValue: (state, action: PayloadAction<IFormAction>) => {
      const { id, ...rest } = action.payload
        state[id] = {...state[id],...rest}

    },
    resetFormWithId: (state, action: PayloadAction<string>) => {
      const formId = action.payload

      if (state[formId]) {
        delete state[formId]
      }
    },
  },
})

export const FormsActions = {
  ...FormsSlice.actions,
}

export const FormsReducer = FormsSlice.reducer